import { cn } from "utils/helpers";

export type PillDisplayType = "sector" | "discipline";

const PILL_COLOURS: Record<PillDisplayType, string> = {
	sector: "bg-green-100 text-green-700",
	discipline: "bg-blue-50 text-blue-700",
};

const PillDisplay = ({ name, type }: { name: string, type: PillDisplayType }) => {

	return <span
		className={cn("rounded-full px-3 py-1 text-xs font-medium",
			PILL_COLOURS[type]
		)}
	>
		{name}
	</span>
}

export default PillDisplay;